import React, { useState } from 'react';
import { EmailAuthProvider } from 'firebase/auth/web-extension';
import { auth } from '../../firebase';
import { reauthenticateWithCredential, updatePassword } from 'firebase/auth/cordova';
import { Form, FormGroup, Label, Input, Button, Alert, Container, Row, Col } from 'reactstrap';
import { errorToast, successToast } from '../common/toast';
import 'firebase/compat/auth';

const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleChangePassword = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            errorToast("New passwords don't match.");
            return;
        }

        try {
            const user = auth.currentUser;
            if (user) {
                const credential = EmailAuthProvider.credential(
                    user.email,
                    currentPassword
                );

                // Reauthenticate with credential
                await reauthenticateWithCredential(user, credential);

                // Update the password
                await updatePassword(user, newPassword);

                successToast('Password updated successfully!');
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            }
        } catch (error) {
            if (error.code === 'auth/wrong-password') {
                errorToast("The current password is incorrect.");
            } else if (error.code === 'auth/too-many-requests') {
                errorToast("Too many attempts. Please try again later.");
            } else if (error.code === 'auth/requires-recent-login') {
                errorToast("Please log in again and retry the password change.");
            } else {
                errorToast(error.message);
            }
            errorToast("Error:", error);
        }
    };

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <h2 className="text-center">Change Password</h2>
                    <Form onSubmit={handleChangePassword}>
                        <FormGroup>
                            <Label for="currentPassword">Current Password</Label>
                            <Input
                                type="password"
                                id="currentPassword"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                required
                                placeholder="Enter current password"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="newPassword">New Password</Label>
                            <Input
                                type="password"
                                id="newPassword"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                                placeholder="Enter new password"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="confirmPassword">Confirm New Password</Label>
                            <Input
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                placeholder="Confirm new password"
                            />
                        </FormGroup>
                        <Button color="primary" type="submit" block>
                            Change Password
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default ChangePassword;
